import { Link } from 'react-router-dom';
import CookieSettingsButton from '../../consent/CookieSettingsButton';
import './EduFooter.css';

const COLUMNS = [
  {
    title: 'Prepare',
    items: [
      ['LNAT', '/lnat'],
      ['TMUA', '/tmua'],
      ['TARA', '/tara'],
      ['UCAT', '/ucat'],
      ['ESAT', '/esat'],
      ['Oxbridge', '/oxbridge'],
      ['Medicine', '/medicine'],
      ['Dentistry', '/dentistry'],
      ['Degree apprenticeships', '/degree-apprenticeships'],
    ],
  },
  {
    title: 'Built for',
    items: [
      ['For learners', '/for-learners'],
      ['For parents and carers', '/for-parents'],
      ['For teachers', '/for-teachers'],
      ['For schools', '/for-schools'],
    ],
  },
  {
    title: 'Features',
    items: [
      ['Overview', '/features'],
      ['Cases', '/features/cases'],
      ['Interviews', '/features/interviews'],
      ['Paths', '/features/paths'],
      ['Builder', '/features/builder'],
    ],
  },
  {
    title: 'Learn',
    items: [
      ['Methodology', '/method'],
      ['Insights', '/insights'],
    ],
  },
  {
    title: 'IVORI',
    items: [
      ['Plans and pricing', '/pricing'],
      ['IVORI Lab', 'https://ivorilab.com'],
      ['IVORI AI', 'https://ivoriai.com'],
      ['Legal Center', '/legal'],
    ],
  },
];

// Instagram and TikTok are IVORI Edu's own accounts and stay on Edu pages only; the
// ivoriai.com company page has its own footer, which carries the two LinkedIn pages.
const SOCIAL = [
  ['Instagram', 'https://www.instagram.com/ivoriedu/'],
  ['TikTok', 'https://www.tiktok.com/@ivori.edu'],
  ['IVORI Edu on LinkedIn', 'https://www.linkedin.com/showcase/ivoriedu/posts/?feedView=all'],
  ['IVORI Lab on LinkedIn', 'https://www.linkedin.com/company/ivorilab/posts/?feedView=all'],
];

function FooterLink({ href, children }) {
  if (href.indexOf('http') === 0) {
    return <a href={href}>{children}</a>;
  }
  return <Link to={href}>{children}</Link>;
}

export default function EduFooter() {
  return (
    <footer className="mkt-footer">
      <div className="mkt-footer-inner">
        <div className="mkt-footer-cols">
          {COLUMNS.map((column) => (
            <div className="mkt-footer-col" key={column.title}>
              <div className="mkt-footer-title">{column.title}</div>
              {column.items.map(([label, href]) => (
                <FooterLink key={href} href={href}>{label}</FooterLink>
              ))}
            </div>
          ))}
        </div>
        <Link className="mkt-footer-wordmark" to="/" aria-label="IVORI Edu home">
          <span>IVORI</span>
          <span>Edu</span>
        </Link>
        <div className="mkt-footer-legal">
          <span>© 2026 IVORI LIMITED. IVORI is among our registered and unregistered trademarks in the U.K. and other countries.</span>
          <nav className="mkt-footer-social" aria-label="IVORI on social media">
            {SOCIAL.map(([label, href]) => (
              <a key={href} href={href} target="_blank" rel="noopener noreferrer">{label}</a>
            ))}
          </nav>
          <CookieSettingsButton />
        </div>
      </div>
    </footer>
  );
}
